import { render, staticRenderFns } from "./DvTextOrImageField.vue?vue&type=template&id=074dbbc1&scoped=true&lang=pug"
import script from "./DvTextOrImageField.vue?vue&type=script&lang=js"
export * from "./DvTextOrImageField.vue?vue&type=script&lang=js"
import style0 from "./DvTextOrImageField.vue?vue&type=style&index=0&id=074dbbc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074dbbc1",
  null
  
)

export default component.exports